module.exports = __webpack_public_path__ + "static/cloud-d069a2760cdce17af14fe3afea0901af.png";